module.exports = __webpack_public_path__ + "static/media/servicio_analisis.4bc33a92.jpg";